module.exports = __webpack_public_path__ + "img/2800f.bc37cb6b.png";